import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
  Validators
} from '@angular/forms';
import { constant } from 'app/app.constants';

@Component({
  selector: 'app-input-phone-number',
  templateUrl: './input-phone-number.component.html',
  styleUrls: ['./input-phone-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPhoneNumberComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputPhoneNumberComponent),
      multi: true
    }
  ],
})

export class InputPhoneNumberComponent implements OnInit, ControlValueAccessor, Validator {

  @Input() placeholder: string;
  MASK_PHONE = constant.MASK_PHONE;
  REGEX: any = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  disabled: boolean;
  form: FormGroup;
  errors = [];

  onChangeFn = (_: any) => {};
  onTouchedFn = () => {};
  onValidationChangeFn = () => {};

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  ngOnInit() {
    this.form.valueChanges.subscribe((val) => {
      this.onChangeFn(val.phone);
      this.onValidationChangeFn();
    });
  }

  initForm() {
    this.form = this.fb.group({
      phone: [null, Validators.pattern(new RegExp(this.REGEX))]
    });
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidationChangeFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.form.disable() : this.form.enable();
  }

  validate(control: AbstractControl): { [key: string]: any; } {
    control.errors ? this.errors.push(control.errors) : null;
    return this.form.invalid ?  { invalid: true } : null;
  }

  writeValue(obj: any): void {
    this.form.setValue({ phone: '' });
    if (obj) {
      this.form.setValue({ phone: obj.trim() }, {emitEvent: true});
    }
  }

  get isRequired(): boolean {
    if (this.errors) {
      const error = this.errors.filter((error) => error.required || error.invalidRequired)
      return error.length > 0;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/phone-number/component/input-phone-number/input-phone-number.component.ts